import { toast } from 'react-toastify'
import { type Response } from '../../../../../hooks/use-fetch'

/**
 * Program-status writes fan out one call per building. Toasts each distinct failure and
 * answers whether the step may advance.
 */
export const allWritesSucceeded = (results: Array<Response<unknown>>): boolean => {
  const failures = results.filter(result => !result.success)
  if (failures.length === 0) return true

  const errors = failures.flatMap(result => result.errors)
  const distinct = Array.from(new Set(errors.length > 0 ? errors : ['Program status could not be saved.']))
  distinct.forEach(error => { toast.error(error) })
  return false
}
